import {
  Shield,
  Sparkles,
  MoveHorizontal,
  Droplets,
  Settings2,
  Maximize2,
  Cpu,
} from "lucide-react";

import { Reveal, RevealStagger, RevealItem } from "@/components/Reveal";
import { FEATURES } from "@/lib/site";

const iconMap = {
  Shield,
  Sparkles,
  MoveHorizontal,
  Droplets,
  Settings2,
  Maximize2,
  Cpu,
};

export default function WhyChooseSection() {

    return (




      <section data-testid="why-section" className="relative py-24 md:py-36 bg-white">
        {/* WHY CHOOSE */}
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-20">
            <Reveal className="lg:col-span-7">
              <div className="overline text-stenzia-green"><span className="kbd-line" /> Why Choose Stenzia</div>
              <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-[64px] tracking-tighter text-charcoal leading-[1.02]">
                Built like industrial machinery.<br />
                <span className="italic text-stenzia-green">Finished like furniture.</span>
              </h2>
            </Reveal>
            <Reveal delay={1} className="lg:col-span-5">
              <p className="text-charcoal/65 text-base md:text-lg leading-relaxed">
                Every Stenzia stand is over-engineered for the realities of a working showroom — daily traffic, slab weight, humidity, and decades of use. The result: display systems that elevate your brand and outlast every alternative.
              </p>
            </Reveal>
          </div>

          <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {FEATURES.map((f, idx) => {
              const Icon = iconMap[f.icon] || Shield;
              const wide = idx === 0 ? "lg:col-span-2" : "";
              return (
                <RevealItem key={f.title} className={wide}>
                  <div
                    data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group relative h-full bg-[#F6F7F5] rounded-3xl p-8 md:p-10 border border-transparent hover:border-stenzia-green/20 hover:bg-white hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 overflow-hidden"
                  >
                    <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-stenzia-green/5 group-hover:bg-stenzia-green/10 transition-colors duration-700" />
                    <div className="relative">
                      <div className="w-14 h-14 rounded-2xl bg-stenzia-green text-white flex items-center justify-center mb-6 group-hover:rotate-6 group-hover:scale-110 transition-all duration-500 shadow-lg shadow-stenzia-green/20">
                        <Icon size={22} />
                      </div>
                      <h3 className="font-display text-xl md:text-2xl text-charcoal tracking-tight">{f.title}</h3>
                      <p className="mt-3 text-sm md:text-base text-charcoal/65 leading-relaxed">{f.body}</p>
                    </div>
                  </div>
                </RevealItem>
              );
            })}
          </RevealStagger>
        </div>
      </section>


  );

}